export default {
  namespaced: true, 
  state: {
      todosLoaded: true
  },
  mutations: {
  },
  actions: {
    justMe() {
        console.log('Hello Worls here')
    }
  }

}
  